import { useCallback, useRef, useState } from 'react';

export default function useStateRef<T>(
  initialValue: T | (() => T),
): [T, React.RefObject<T>, React.Dispatch<React.SetStateAction<T>>] {
  const [value, setValue] = useState(initialValue);
  const valueRef = useRef(
    initialValue instanceof Function ? initialValue() : initialValue,
  );

  const setValueRef = useCallback(
    (dispatch: Parameters<typeof setValue>[0]) => {
      setValue(dispatch);
      if (dispatch instanceof Function)
        valueRef.current = dispatch(valueRef.current);
      else valueRef.current = dispatch;
    },
    [],
  );

  return [value, valueRef, setValueRef];
}
